<template >
    <div class="container-fluid" v-if="city">
      <h1>{{city.name}} ({{city.shortName}})</h1>
      <p>{{city.description}}</p>
      
      <button type="button" class="my-3 btn btn-primary" data-toggle="modal" data-target="#depModal">
        Дүүрэг сум нэмэх
      </button>
      <div>
            <add-bulk :path="'countries/'+countryId+'/cities/'+city.id+'/districts'" :parentPath="'countries/'+countryId+'/cities/'+city.id"></add-bulk>
      </div>
      <!-- DataTales Example -->
      <div class="card shadow mb-4" >
        <div class="card-header py-3">
          <h6 class="m-0 font-weight-bold text-primary">Дүүрэг сум</h6>
        </div>
        <div class="card-body" v-if="districts!=null && districts.length>0">
          <div class="table-responsive">
            <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Нэр</th>
                  <th>Дэлгэрэнгүй</th>

                  <th>Үйлдэл</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(dep, index) in districts" v-bind:key="dep.id">
                  <td>{{index+1}}</td>
                  <td>{{dep.name}} ({{dep.shortName}})</td>
                  <td>{{dep.description}}</td>
                  <!-- <td>{{topic.createdAt | formatDate}}</td> -->

                  <td>
                    <button class="btn btn-primary btn-sm" @click="goDetail(dep)">xараx</button>
                    <button class="btn btn-warning btn-sm ml-2" @click="_editDepartment(dep)">засах</button>
                    <!-- <button class="btn btn-danger" @click="_deleteDepartment(dep)">устгах</button> -->
                  </td>
                </tr>
                
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="alert alert-warning">Одоогоор тэнхимийн мэдээлэл ороогүй байна.</div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="depModal" tabindex="-1" role="dialog" aria-labelledby="depModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="depModalLabel">Дүүрэг сум</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
                <div class="form-group">
                  <input v-model.trim="district.name" class="form-control" aria-describedby="emailHelp" placeholder="Хөтөлбөрийн багийн нэр">
                </div>
                <div class="form-group">
                  <input v-model.trim="district.shortName" class="form-control" aria-describedby="emailHelp" placeholder="Хөтөлбөрийн багийн товчилсон нэр">
                </div>
                <div class="form-group">
                  <textarea rows="10" v-model.trim="district.description" class="form-control" id="exampleInputPassword" placeholder="Хөтөлбөрийн багийн дэлгэрэнгүй"/>
                </div>

         
                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
              <button @click="saveTopic" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Xадгалаx</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import AddBulk from './AddBulk'

export default {
    components:{
        AddBulk
    },
    name: "CityDetail",
    data() {
        return {
            city: null,
            district:{
              'name':null,
              'shortName':null,
              'description':null
            },
            districts:[],

            
        };
    },
    methods: {
        
      _getQA(){

          fb.db.collection("countries").doc(this.countryId).collection("cities").doc(this.schoolId).onSnapshot(doc=> {
              let city=doc.data()
              city.id=doc.id
              this.city=city;
          
            
          });
          fb.db.collection("countries").doc(this.countryId).collection("cities").doc(this.schoolId).collection("districts").onSnapshot(querySnapshot=> {
            this.districts=[]
            querySnapshot.forEach(doc=> {
              let object=doc.data()
              object.id = doc.id
					    this.districts.push(object);
            });
            
          });

      },

      saveTopic() {
          if(this.district!=null && this.district!=null && this.district.name!=''){
            if(this.district.id!=null && this.district.id!=''){
              fb.db.collection("countries").doc(this.countryId).collection("cities").doc(this.schoolId).collection("districts").doc(this.district.id).update({
                'name':this.district.name,
                'shortName':this.district.shortName,
                'description':this.district.description,
                'modifiedAt':new Date(),
                'modifiedUser':fb.usersCollection.doc(this.$store.getters.currentUser.uid)
              })
            }
            else{
              this.district.createdAt=new Date()
              fb.db.collection("countries").doc(this.countryId).collection("cities").doc(this.schoolId).collection("districts").doc().set(this.district)
              fb.db.collection("countries").doc(this.countryId).collection("cities").doc(this.schoolId).update({numberOfDepartments: fb.firestore.FieldValue.increment(1)})
            }
            this.district={
                'name':null,
                'shortName':null,
                'description':null
              }
          }
      },

      goDetail(dep){
        this.$router.push({ name: 'Khoroos', params: { countryId: this.countryId, schoolId: this.schoolId, districtId: dep.id} });
      },
      _editDepartment(dep){
          this.district= Object.assign({}, dep);
          $('#depModal').modal('toggle');
      },
      _deleteDepartment(dep){
          var result = confirm("Та "+dep.name+" сум дүүрэг устгах уу?");
          if (result) {
              fb.db.collection("countries").doc(this.countryId).collection("cities").doc(this.schoolId).collection("districts").doc(dep.id).delete()
          }

      }
   

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        schoolId: { 
            required: true,
        },
        countryId:{
          required:true
        }
    },
    created() {
        var _this=this;
        console.log(this.schoolId);
        if(this.schoolId!=null && this.schoolId!='' && this.countryId!=null && this.countryId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).fromNow()
        }
        return '-'
      },
    
    }
  
};
</script>

